import * as React from 'react'
import { MainBlock } from '@blocks/BlockMain/model'
import { DisclaimerMain } from '@shared/components/disclaimer-main'

export const ipotekaNerezMainBlock: MainBlock = {
	title: 'Ипотека для нерезидентов в %city_pr%',
	// subtitle: 'Получите деньги на покупку квартиры быстро и без походов в офис',
	textItems: ['От 4,7% годовых', 'Одобрение суммы до 30 млн рублей', 'Срок — до 35 лет'],
	buttonText: 'Оставить заявку',
	footDisclaimer: <DisclaimerMain />,
	faceImageName: {
		mobile: 'ipotekaNerezMobile.png',
		tablet: 'ipotekaNerezTablet.png',
		default: 'ipotekaNerez.png',
	},
	imageAlt: 'Владимир Холодилов, руководитель отдела по работе с клиентами',
}
